import { render, staticRenderFns } from "./order-forms-nologin-create-confirm.vue?vue&type=template&id=3118d2f9"
import script from "./order-forms-nologin-create-confirm.vue?vue&type=script&lang=js"
export * from "./order-forms-nologin-create-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports